<div class="page-title-right">
  <ol class="breadcrumb m-0">
    <li class="breadcrumb-item"><a routerLink="/admin/bio">Bio</a></li>
    <li class="breadcrumb-item active">Métricas</li>
  </ol>
</div>

<div class="d-flex justify-content-between align-items-center mb-3">
  <h4 class="page-title mb-0">
    <i class="fas fa-chart-line mr-2"></i>
    Métricas da Bio
  </h4>
  <div class="periodo-selector">
    <button *ngFor="let p of periodos" class="periodo-btn"
            [class.ativo]="periodoSelecionado === p.valor"
            (click)="alterarPeriodo(p.valor)">
      {{p.label}}
    </button>
  </div>
</div>

<!-- Loading -->
<div class="text-center p-5" *ngIf="carregando">
  <div class="k-i-loading" style="font-size: 40px;"></div>
</div>

<!-- Sem bio page -->
<div class="card" *ngIf="!carregando && !idBioPagina">
  <div class="card-body text-center p-5">
    <i class="fas fa-chart-bar fa-3x text-muted mb-3"></i>
    <p class="text-muted">Configure primeiro a página Bio para visualizar as métricas.</p>
    <a routerLink="/admin/bio/configuracoes" class="btn btn-primary">
      <i class="fas fa-cog mr-1"></i> Ir para Configurações
    </a>
  </div>
</div>

<!-- Sem metricas -->
<div class="card" *ngIf="!carregando && idBioPagina && !metricas">
  <div class="card-body text-center p-5">
    <i class="fas fa-chart-bar fa-3x text-muted mb-3"></i>
    <h5 class="text-muted">Nenhuma métrica disponível</h5>
    <p class="text-muted">As métricas aparecerão após a página Bio receber visitas.</p>
  </div>
</div>

<!-- ============ DASHBOARD ============ -->
<div class="bio-dashboard" *ngIf="!carregando && metricas" [class.heatmap-expandido]="heatmapExpandido">

  <!-- VISÃO DASHBOARD -->
  <div class="dashboard-content" *ngIf="!heatmapExpandido">

    <!-- KPI Cards -->
    <div class="kpi-row">
      <div class="kpi-card">
        <div class="kpi-header">
          <span class="kpi-label">Visitas <i class="fas fa-info-circle kpi-info"></i></span>
          <i class="fas fa-users kpi-icon"></i>
        </div>
        <div class="kpi-valor">{{metricas.totalVisitas | number}}</div>
        <div class="kpi-rodape">
          <span class="kpi-variacao" *ngIf="variacaoVisitas !== 0"
                [class.positiva]="variacaoVisitas > 0" [class.negativa]="variacaoVisitas < 0">
            <i class="fas" [ngClass]="{'fa-arrow-up': variacaoVisitas > 0, 'fa-arrow-down': variacaoVisitas < 0}"></i>
            {{variacaoVisitas > 0 ? '+' : ''}}{{variacaoVisitas | number:'1.1-1'}}%
          </span>
          <span class="kpi-sub" *ngIf="variacaoVisitas === 0">no período</span>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-header">
          <span class="kpi-label">Cliques Totais <i class="fas fa-info-circle kpi-info"></i></span>
          <i class="fas fa-mouse-pointer kpi-icon"></i>
        </div>
        <div class="kpi-valor">{{metricas.totalCliques | number}}</div>
        <div class="kpi-rodape">
          <span class="kpi-variacao" *ngIf="variacaoCliques !== 0"
                [class.positiva]="variacaoCliques > 0" [class.negativa]="variacaoCliques < 0">
            <i class="fas" [ngClass]="{'fa-arrow-up': variacaoCliques > 0, 'fa-arrow-down': variacaoCliques < 0}"></i>
            {{variacaoCliques > 0 ? '+' : ''}}{{variacaoCliques | number:'1.1-1'}}%
          </span>
          <span class="kpi-sub" *ngIf="variacaoCliques === 0">média de {{mediaCliques | number:'1.1-1'}} cliques por visita</span>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-header">
          <span class="kpi-label">CTR Geral <i class="fas fa-info-circle kpi-info"></i></span>
          <i class="fas fa-chart-bar kpi-icon"></i>
        </div>
        <div class="kpi-valor">{{metricas.taxaConversao | number:'1.1-1'}}%</div>
        <div class="kpi-rodape">
          <span class="kpi-sub">média do período</span>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-header">
          <span class="kpi-label">Cliques na Oferta <i class="fas fa-info-circle kpi-info"></i></span>
          <i class="fas fa-bullhorn kpi-icon"></i>
        </div>
        <div class="kpi-valor">{{cliquesOfertas | number}}</div>
        <div class="kpi-rodape">
          <span class="kpi-sub">{{participacaoOfertas | number:'1.1-1'}}% do total de cliques</span>
        </div>
      </div>
    </div>

    <div class="dash-card dash-card--insights mb-4">
      <div class="dash-card-header">
        <span class="dash-card-titulo">Insights Automáticos</span>
      </div>
      <div class="dash-card-body">
        <div class="insights-list">
          <div class="insight-item"
               *ngFor="let insight of insightsAutomaticos"
               [ngClass]="'insight-' + insight.prioridade">
            <div class="insight-item__icon">
              <i [class]="insight.icone"></i>
            </div>
            <div class="insight-item__content">
              <div class="insight-item__title">{{insight.titulo}}</div>
              <div class="insight-item__desc">{{insight.descricao}}</div>
              <div class="insight-item__hint">
                <strong>Ação sugerida:</strong> {{insight.sugestao}}
              </div>
            </div>
            <span class="insight-item__badge">{{insight.prioridade}}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Grid de Cards (2 colunas) -->
    <div class="cards-grid">

      <!-- Card: Visitas e Cliques por Dia -->
      <div class="dash-card">
        <div class="dash-card-header">
          <span class="dash-card-titulo">Visitas e Cliques por Dia</span>
        </div>
        <div class="dash-card-body">
          <div class="chart-container" *ngIf="metricas.visitasPorDia?.length">
            <canvas #chartVisitas></canvas>
          </div>
          <div class="empty-state-mini" *ngIf="!metricas.visitasPorDia?.length">
            <i class="fas fa-chart-area"></i>
            <span>Sem dados de tráfego</span>
          </div>
        </div>
      </div>

      <!-- Card: Heatmap da Bio -->
      <div class="dash-card">
        <div class="dash-card-header">
          <span class="dash-card-titulo">Heatmap da Bio</span>
        </div>
        <div class="dash-card-body heatmap-preview-body">
          <div class="heatmap-phone-mini" *ngIf="urlPreview">
            <div class="phone-mini-frame">
              <iframe #iframePreview
                      [src]="urlPreview"
                      class="phone-mini-iframe"
                      frameborder="0"
                      scrolling="no"
                      (load)="onIframeLoad()">
              </iframe>
            </div>
          </div>
          <div class="empty-state-mini" *ngIf="!urlPreview">
            <i class="fas fa-mobile-alt"></i>
            <span>Configure a Bio para ver o heatmap</span>
          </div>
          <button class="btn-expandir-heatmap" (click)="expandirHeatmap()" *ngIf="urlPreview">
            <i class="fas fa-expand-arrows-alt mr-1"></i> Expandir heatmap
          </button>
        </div>
      </div>

      <!-- Card: Ranking de Cliques -->
      <div class="dash-card">
        <div class="dash-card-header">
          <span class="dash-card-titulo">Ranking de Cliques</span>
        </div>
        <div class="dash-card-body">
          <div class="chart-container-ranking" *ngIf="metricas.cliquesPorItem?.length">
            <canvas #chartRanking></canvas>
          </div>
          <div class="empty-state-mini" *ngIf="!metricas.cliquesPorItem?.length">
            <i class="fas fa-trophy"></i>
            <span>Sem cliques registrados</span>
          </div>
        </div>
      </div>

      <!-- Card: Funil Rápido -->
      <div class="dash-card">
        <div class="dash-card-header">
          <span class="dash-card-titulo">Funil Rápido</span>
        </div>
        <div class="dash-card-body funil-body">
          <div class="funil-visual">
            <div class="funil-etapa funil-etapa-1">
              <span class="funil-valor">{{metricas.totalVisitas | number}} Visitas</span>
            </div>
            <div class="funil-etapa funil-etapa-2">
              <span class="funil-valor">{{metricas.totalCliques | number}} Cliques</span>
            </div>
            <div class="funil-etapa funil-etapa-3">
              <span class="funil-valor">{{cliquesCardapio | number}} cliques no Cardápio</span>
            </div>
            <div class="funil-etapa funil-etapa-ifood" *ngIf="cliquesIfood > 0">
              <span class="funil-valor">{{cliquesIfood | number}} cliques no iFood</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Card: CTR por Link/Oferta -->
      <div class="dash-card">
        <div class="dash-card-header">
          <span class="dash-card-titulo">CTR por Link / Oferta</span>
        </div>
        <div class="dash-card-body">
          <div class="table-responsive" *ngIf="metricas.ctrPorLink?.length">
            <table class="table table-sm tabela-ctr mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Item</th>
                  <th class="text-right">Cliques</th>
                  <th class="text-right">CTR</th>
                  <th style="width: 120px"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of metricas.ctrPorLink; let i = index">
                  <td class="text-muted font-weight-bold">{{c.posicao > 0 ? c.posicao : (i + 1)}}</td>
                  <td>
                    <strong>{{c.titulo}}</strong>
                    <span class="badge ml-1" [ngClass]="c.tipoItem === 'oferta' ? 'badge-oferta' : 'badge-link'">{{c.tipoItem}}</span>
                  </td>
                  <td class="text-right">{{c.cliques | number}}</td>
                  <td class="text-right font-weight-bold">{{c.ctr | number:'1.1-1'}}%</td>
                  <td>
                    <div class="progress" style="height: 6px;">
                      <div class="progress-bar" role="progressbar"
                           [style.width.%]="maxCtrPorLink > 0 ? (c.ctr / maxCtrPorLink) * 100 : 0"
                           style="background-color: #4F6BED;">
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="empty-state-mini" *ngIf="!metricas.ctrPorLink?.length">
            <i class="fas fa-percentage"></i>
            <span>Sem dados de CTR</span>
          </div>
        </div>
      </div>

      <!-- Card: Origem do Tráfego (doughnut + tabela) -->
      <div class="dash-card">
        <div class="dash-card-header">
          <span class="dash-card-titulo">Origem do Tráfego</span>
        </div>
        <div class="dash-card-body">
          <div class="origens-layout" *ngIf="metricas.origens?.length">
            <div class="chart-container-origens">
              <canvas #chartOrigens></canvas>
            </div>
            <div class="table-responsive mt-3">
              <table class="table table-sm tabela-origens mb-0">
                <thead>
                  <tr>
                    <th>Origem</th>
                    <th class="text-right">Visitas</th>
                    <th class="text-right">Únicos</th>
                    <th class="text-right">Cliques</th>
                    <th class="text-right">CTR</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let o of metricas.origens">
                    <td>
                      <i [class]="obtenhaIconeOrigem(o.origem)" [style.color]="obtenhaCorOrigem(o.origem)" class="mr-2"></i>
                      {{obtenhaLabelOrigem(o.origem)}}
                    </td>
                    <td class="text-right">{{o.visitas | number}}</td>
                    <td class="text-right">{{o.visitantesUnicos | number}}</td>
                    <td class="text-right">{{o.cliques | number}}</td>
                    <td class="text-right font-weight-bold">{{o.ctr | number:'1.1-1'}}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="empty-state-mini" *ngIf="!metricas.origens?.length">
            <i class="fas fa-globe"></i>
            <span>Sem dados de origem</span>
          </div>
        </div>
      </div>

      <!-- Card: Dispositivos -->
      <div class="dash-card">
        <div class="dash-card-header">
          <span class="dash-card-titulo">Dispositivos</span>
        </div>
        <div class="dash-card-body">
          <div class="table-responsive" *ngIf="metricas.dispositivos?.length">
            <table class="table table-sm tabela-dispositivos mb-0">
              <thead>
                <tr>
                  <th>Dispositivo</th>
                  <th class="text-right">Visitas</th>
                    <th class="text-right">Únicos</th>
                  <th class="text-right">%</th>
                  <th style="width: 120px"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let d of metricas.dispositivos">
                  <td>
                    <i [class]="obtenhaIconeDispositivo(d.dispositivo)" [style.color]="obtenhaCorDispositivo(d.dispositivo)" class="mr-2"></i>
                    {{d.dispositivo}}
                  </td>
                  <td class="text-right">{{d.visitas | number}}</td>
                  <td class="text-right">{{d.visitantesUnicos | number}}</td>
                  <td class="text-right font-weight-bold">{{d.percentual | number:'1.1-1'}}%</td>
                  <td>
                    <div class="progress" style="height: 6px;">
                      <div class="progress-bar" role="progressbar"
                           [style.width.%]="d.percentual"
                           [style.backgroundColor]="obtenhaCorDispositivo(d.dispositivo)">
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="empty-state-mini" *ngIf="!metricas.dispositivos?.length">
            <i class="fas fa-mobile-alt"></i>
            <span>Sem dados de dispositivos</span>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- ============ HEATMAP EXPANDIDO ============ -->
  <div class="heatmap-fullview" *ngIf="heatmapExpandido">
    <div class="d-flex align-items-center mb-4" style="gap: 12px;">
      <button class="btn-voltar-dashboard" (click)="fecharHeatmap()">
        <i class="fas fa-arrow-left mr-2"></i> Voltar
      </button>
      <h4 class="page-title mb-0 flex-grow-1">
        <i class="fas fa-fire text-danger mr-2"></i>
        Heatmap de Cliques
      </h4>
      <button class="btn btn-outline-secondary btn-sm" (click)="recarregarPreview()">
        <i class="fas fa-sync-alt mr-1"></i> Atualizar
      </button>
    </div>

    <div class="heatmap-fullview-body">
      <div class="heatmap-phone-full">
        <div class="phone-frame">
          <div class="phone-notch"></div>
          <div class="phone-screen">
            <iframe #iframePreviewFull
                    [src]="urlPreview"
                    class="preview-iframe"
                    frameborder="0"
                    scrolling="yes"
                    (load)="onIframeLoadFull()">
            </iframe>
          </div>
          <div class="phone-home-bar"></div>
        </div>
      </div>

      <div class="heatmap-detalhes">
        <div class="card mb-3">
          <div class="card-body">
            <h6 class="font-weight-bold mb-3">Ranking de Cliques</h6>
            <div class="ranking-lista" *ngIf="metricas.cliquesPorItem?.length">
              <div class="ranking-item" *ngFor="let item of metricas.cliquesPorItem; let i = index">
                <span class="ranking-pos">#{{i + 1}}</span>
                <div class="ranking-info">
                  <span class="ranking-nome">{{item.titulo}}</span>
                  <div class="ranking-barra-container">
                    <div class="ranking-barra"
                         [style.width.%]="item.percentual"
                         [style.backgroundColor]="coresRanking[i] || '#4F6BED'">
                    </div>
                  </div>
                </div>
                <span class="ranking-percentual">{{item.percentual | number:'1.1-1'}}%</span>
              </div>
            </div>
          </div>
        </div>

        <div class="card" *ngIf="metricas.ctrPorLink?.length">
          <div class="card-body">
            <h6 class="font-weight-bold mb-3">CTR por Link / Oferta</h6>
            <div class="table-responsive">
              <table class="table table-sm tabela-ctr mb-0">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th class="text-right">Cliques</th>
                    <th class="text-right">CTR</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let c of metricas.ctrPorLink">
                    <td><strong>{{c.titulo}}</strong></td>
                    <td class="text-right">{{c.cliques | number}}</td>
                    <td class="text-right font-weight-bold">{{c.ctr | number:'1.1-1'}}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
